export const API_BASE = process.env.OMNIPLATFORM_API;
export const API_PATH = 'cutoff-dates';
